import { render, staticRenderFns } from "./BarChartContainer.vue?vue&type=template&id=008659b7&scoped=true&"
import script from "./BarChartContainer.vue?vue&type=script&lang=js&"
export * from "./BarChartContainer.vue?vue&type=script&lang=js&"
import style0 from "./BarChartContainer.vue?vue&type=style&index=0&id=008659b7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "008659b7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!C:/Users/acarmichael/Desktop/DEV/BOSS40-FrontEnd/boss-client/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VBtn,VFlex,VIcon,VLayout})
